import { Component, Inject, OnDestroy } from "@angular/core";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { PersonDataService } from "../../../core/persons.dataservice";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import * as dataCore from "../../../core/datacore";


@Component({
    selector: "crew-person-edit-role",
    template: require('./person.role.edit.component.html')
})
export class PersonRoleEditComponent implements OnDestroy {

    private unsubribe: Function;

    public From: Date;
    public To: Date;

    public get checkFrom(): boolean {
        return !this.From;
    }

    public get checkTo(): boolean {
        return !this.To;
    }

    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("person") public person: Nema.Crew.Model.Person,
        @Inject("personRole") public personRole: Nema.Crew.Model.PersonRole,
        @Inject("roleTypes") public roleTypes: Nema.Crew.Model.RoleType[],
        private stateService: StateService,
        transitionService: TransitionService,
        private dialog: MatDialog,
        @Inject('$log') private $log: ng.ILogService,
        @Inject("isNew") private isNew: boolean) {

        this.From = dataCore.addTimezoneOffset(this.personRole.From);
        this.To = dataCore.addTimezoneOffset(this.personRole.To);

        this.cleanUpSubscription();

        this.unsubribe = transitionService.onBefore({}, transition => {

            var hasChanges = this.personDataService.hasChanges();
            if (hasChanges) {

                let dialogRef = this.dialog.open(ConfirmDialog);

                dialogRef.componentInstance.content = "There are unsaved changes, do you want to continue?";
                dialogRef
                    .afterClosed()
                    .subscribe(res => {
                        if (res) {
                            this.rejectChanges();
                            transition.run();
                        }
                    });

                return false;
            }

            return true;
        });
    }

    public entityDisplayName = "Person Job Role";

    public listStateName = "app.resources.persons.detail";

    private cleanUpSubscription() {
        if (this.unsubribe) {
            this.unsubribe();
            this.unsubribe = null;
        }
    }

    public ngOnDestroy() {
        this.cleanUpSubscription();
    }

    public save() {

        if (this.isNew) {
            this.personRole = this.personDataService.newPersonRole(this.person.Id, this.personRole.RoleTypeId);
        }

        this.personRole.From = dataCore.subtractTimezoneOffset(this.From);
        this.personRole.To = dataCore.subtractTimezoneOffset(this.To);

        this.personDataService
            .save(this.personRole.Person)
            .then(() => {
                this.$log.info("Successfully saved " + this.entityDisplayName);
                this.backToList();
            })
            .catch(err => this.$log.error("Could not save " + this.entityDisplayName + ", error occured: " + err));
    }

    private rejectChanges() {
        this.personDataService.rejectChanges();
    }

    public cancel() {
        this.rejectChanges();
        this.backToList();
    }

    public backToList(): void {
        this.stateService.go(this.listStateName, { id: this.personRole.PersonId });
    }

    public getTodayOrNull(checked: boolean): Date {
        return dataCore.getTodayOrNull(checked);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/roles/person.role.edit.component.ts